import axios from './index';
const baseUrl = process.env.NODE_ENV === 'production'? '/api' : '/api';

const API = {
  SelectReport: (data, formData) => axios.post(baseUrl + '/portal/report/selectReport', data, formData, true),
}


export default API
